import { Suspense } from "react";

import { classNames } from "../../../../utils";
import Centered from "../../../ui/Centered";
import LoadingSpinner from "../../../ui/LoadingSpinner";

type Props = {
  children: React.ReactNode;
  narrow?: boolean;
};

export default function Content({ children, narrow }: Props) {
  return (
    <div className="px-4 py-8 sm:px-6 lg:px-8 text-black dark:text-white relative">
      <div className={classNames("space-y-6", narrow && "max-w-4xl mx-auto")}>
        <Suspense
          fallback={
            <Centered>
              <LoadingSpinner />
            </Centered>
          }
        >
          {children}
        </Suspense>
      </div>
    </div>
  );
}

type TitleProps = {
  children: React.ReactNode;
  right?: React.ReactNode;
};

Content.Title = ({ children, right }: TitleProps) => (
  <div className="mt-10 mb-6 flex items-center">
    <h1 className="text-3xl font-semibold flex-1">{children}</h1>
    {right}
  </div>
);
Content.Heading = ({ children, right }: TitleProps) => (
  <div className="mt-10 mb-6 flex items-center">
    <h2 className="text-lg font-semibold flex-1">{children}</h2>
    {right}
  </div>
);
